export const SESSION_CHANNEL_NAME = 'ahaslides-session'

export const announceSignedOut = () => {
  if (typeof BroadcastChannel !== 'function') return
  try {
    const channel = new BroadcastChannel(SESSION_CHANNEL_NAME)
    channel.postMessage({ type: 'signed-out' })
    channel.close()
  } catch (error) {
    // Sign-out must go on without the announcement.
  }
}
